import { BookOpen, Dumbbell, ClipboardCheck, HelpCircle, RotateCcw, Compass } from "lucide-react";

const MODULES = [
  { icon: BookOpen, title: "Learn", desc: "Socratic step-by-step teaching with inline diagrams & voice explanations.", iconBg: "bg-primary/10", iconColor: "text-primary" },
  { icon: Dumbbell, title: "Practice", desc: "Adaptive-difficulty questions that get harder as mastery grows.", iconBg: "bg-secondary/15", iconColor: "text-secondary" },
  { icon: ClipboardCheck, title: "Assess", desc: "Formal & diagnostic assessments that score real chapter mastery.", iconBg: "bg-success/10", iconColor: "text-success" },
  { icon: HelpCircle, title: "Homework Help", desc: "Stuck on a problem? Get guided help without just copying answers.", iconBg: "bg-accent/10", iconColor: "text-accent" },
  { icon: RotateCcw, title: "Revise", desc: "Smart spaced revision that resurfaces exactly what's fading.", iconBg: "bg-destructive/10", iconColor: "text-destructive" },
  { icon: Compass, title: "Explore", desc: "Open-ended curiosity mode for questions beyond the syllabus.", iconBg: "bg-[#9A3DB2]/10", iconColor: "text-[#9A3DB2]" },
];

export default function LandingModules() {
  return (
    <section id="modules" className="py-10 sm:py-16 bg-slate-50/70 border-b border-slate-100" data-testid="landing-modules-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10">
          <p className="text-xs font-bold uppercase tracking-widest text-primary">Six Modules, One Tutor</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2">Everything a great tutor does — built in.</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MODULES.map((m) => (
            <div
              key={m.title}
              data-testid={`module-card-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-card border border-border rounded-2xl p-6 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <div className={`w-11 h-11 rounded-xl ${m.iconBg} flex items-center justify-center mb-4`}>
                <m.icon className={m.iconColor} size={20} />
              </div>
              <h3 className="font-heading font-bold text-lg">{m.title}</h3>
              <p className="text-sm text-muted-foreground mt-1.5">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
